import { ServiceStepEnum, StepKey } from "../types";

const root = "/";
const getStarted = "/get-started";

const generatePath = (step: StepKey) => `${getStarted}${ServiceStepEnum[step]}`;

export const routePaths = {
  root,
  getStarted,
  notServiced: `${getStarted}/not-serviced`,

  additionalFactors: generatePath("additionalFactors"),
  availability: generatePath("availability"),
  calendarWindows: generatePath("calendarWindows"),
  confirmation: generatePath("confirmation"),
  contactInformation: generatePath("contactInformation"),
  destinationLocation: generatePath("destinationLocation"),
  destinationDwellingInformation: generatePath(
    "destinationDwellingInformation",
  ),
  dwellingInformation: generatePath("dwellingInformation"),
  kindOfItems: generatePath("kindOfItems"),
  numberBedrooms: generatePath("numberBedrooms"),
  pickUpLocation: generatePath("pickUpLocation"),
  truckLoads: generatePath("truckLoads"),
  provideMoreDetails: generatePath("provideMoreDetails"),
  targetDate: generatePath("targetDate"),
};
